import { Stack } from '@fluentui/react';
import React, { useEffect } from 'react';

// assets

import { useStore } from '../../../stores/root';
import { faHome } from '@fortawesome/pro-light-svg-icons';
import EmployeeContractDetails from '../../../components/hr/contracts/general/details';
import { useParams } from 'react-router-dom';
import EmployeePayslipDetails from '../../../components/hr/payslips/general/details';

interface HRPayslipDetailsPageProps {
}

const HRPayslipDetailsPage: React.FC<HRPayslipDetailsPageProps> = (props: HRPayslipDetailsPageProps) => {
    const {topbar} = useStore();
    const params: any = useParams();

    useEffect(() => {
        topbar.show("Payslip", [
            {key: "home", icon: faHome, href: "/"},
            {key: "payslips", text: 'Payslips'}
        ]);
    }, []);

    return <Stack>
        <EmployeePayslipDetails payslipId={params.payslipId} />
    </Stack>;
};

export default HRPayslipDetailsPage;
